<template>
    <div v-if="profile">
        <v-dialog width="1000" v-model="$store.state.editProfile">


            <v-card class="white-box">
                <p style="text-align: right">اطلاعات کاربری شما</p>
                <v-divider></v-divider>
                <div class="form-box-white">


                    <v-select dense label="جنسیت" :items="$store.state.gender" value="value" item-text="text" v-model="profile.gender" outlined class="saba-input">
                        <template v-slot:append>
                            <div>
                                <img src="../assets/image/Icons/arrowDown.png" class="arrow-saba"/>
                            </div>
                        </template>
                    </v-select>
                    <v-text-field v-model="profile.fName" dense label="نام" outlined class="saba-input"></v-text-field>
                    <v-text-field v-model="profile.lName" dense label="نام خانوادگی" outlined
                                  class="saba-input"></v-text-field>
                    <v-text-field v-model="profile.fatherName" dense label="نام پدر" outlined
                                  class="saba-input"></v-text-field>
                    <v-text-field v-model="profile.meliCode" dense label="شماره ملی" outlined
                                  class="saba-input"></v-text-field>

                    <v-text-field v-model="profile.fixedNumber" dense label="شماره تماس" outlined
                                  class="saba-input"></v-text-field>
                    <v-text-field v-model="profile.tell" dense label="شماره موبایل" outlined
                                  class="saba-input"></v-text-field>
                    <v-textarea v-model="profile.address" dense rows="1" label="آدرس" outlined
                                class="saba-input"></v-textarea>

                    <v-select v-model="profile.rel" dense label="واحد سازمانی" outlined class="saba-input">
                        <template v-slot:append>
                            <div>
                                <img src="../assets/image/Icons/arrowDown.png" class="arrow-saba"/>
                            </div>
                        </template>

                    </v-select>
                    <v-text-field v-model="profile.post" readonly dense label="سمت" outlined class="saba-input">
                        <template v-slot:append>
                            <div>
                                <img src="../assets/image/Icons/arrowDown.png" class="arrow-saba"/>
                            </div>
                        </template>

                    </v-text-field>
                    <v-select v-model="profile.workType" dense label="نوع همکاری" outlined class="saba-input">
                        <template v-slot:append>
                            <div>
                                <img src="../assets/image/Icons/arrowDown.png" class="arrow-saba"/>
                            </div>
                        </template>

                    </v-select>
                    <v-file-input :prepend-icon="''"
                            small-chips
                            v-model="profile.signFile"
                            truncate-length="4"
                            dense label="فایل امضا"
                            outlined class="saba-input"
                    >
                        <template v-slot:append>
                            <div class="uploadIcon">
                                <img src="../assets/image/Icons/upload.png" class="arrow-saba"/>
                            </div>
                        </template>

                        <template v-slot:selection="{ }">
                            <v-chip
                                    small
                                    label
                            >
                                فایل امضا
                            </v-chip>
                        </template>

                    </v-file-input>

                    <v-text-field v-model="profile.username" dense label="نام کاربری" outlined
                                  class="saba-input"></v-text-field>
                    <v-text-field v-model="profile.password" dense label="کلمه عبور" outlined
                                  class="saba-input"></v-text-field>
                    <v-text-field v-model="profile.email" dense label="ایمیل کاربری" outlined
                                  class="saba-input"></v-text-field>
                    <v-file-input :prepend-icon="''"
                            v-model="profile.image"

                            truncate-length="4"
                            small-chips
                            ref="image"
                            @change="uploadImage"
                            dense label="عکس پروفایل"
                            outlined class="saba-input"
                    >
                        <template v-slot:append>
                            <div class="uploadIcon" @click="uploadImage" >
                                <img src="../assets/image/Icons/upload.png" class="arrow-saba"/>
                            </div>
                        </template>

                        <template v-slot:selection="{ }">
                            <v-chip
                                    x-small
                                    label
                            >
                                عکس پروفایل
                            </v-chip>
                        </template>

                    </v-file-input>

                </div>

                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="setProfile" dark color="#4abbcb" class="btn-saba">
                        ویرایش و تایید
                    </v-btn>
                </v-card-actions>

            </v-card>

        </v-dialog>
    </div>
</template>

<script>

    import {mdiCogOutline, mdiPower, mdiBellRingOutline} from "@mdi/js"
    import axios from "axios"

    export default {

        created() {

            this.get();
        },

        components: {},
        data() {
            return {
                profile: {},
                icon: {mdiPower, mdiCogOutline, mdiBellRingOutline},

            }
        },

        computed: {},

        methods: {

            uploadImage: function (e) {
                let file = e;
                let formData = new FormData();
                formData.append('file', file);
                axios.post(this.$store.state.api + 'imageupload?' +
                    'width=256&' +
                    'height=256&' +
                    'tw=128&' +
                    'th=128&' +
                    'stw=64&' +
                    'sth=64&'
                    , formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then(response => {
                        if (response.data.result) {
                            this.profile.image = response.data.data;
                        }
                    }
                );
            },


            get() {
                axios.post(this.$store.state.api + 'getprofile', {
                    userId: this.$store.state.userId,
                }).then(response => {
                    if (response.data.data) {
                        this.profile = response.data.data;
                    } else {
                        this.logout();
                    }
                });
            }, setProfile() {
                axios.post(this.$store.state.api + 'setprofile', this.profile).then(response => {
                    if (response.data.result) {
                        this.$store.state.editProfile = false;
                        this.$emit('get');

                    }
                });
            },
        }

    }
</script>

<style scoped>

    .arrow-saba {
        width: 20px;
    }

    .btn-saba {
        box-shadow: none !important;
    }

    .form-box-border {
        margin: 20px;
        border-radius: 10px;
    }


    .uploadIcon {
        background-color: #4abbcb;
        border-radius: 10px;
        cursor: pointer;
        padding: 0 5px;
    }

    .form-box-white {
        display: flex;
        flex-wrap: wrap;
    }

    .white-box {
        background-color: #fff;
        border-radius: 10px;
        box-shadow: 0px 0px 10px #ddd;
        padding: 20px;
        max-width: 1000px;
    }

    .saba-input {
        width: 180px;
        margin: 10px;
    }




    .Setting-Header-saba {
        margin: 10px;
        text-align: right;
        cursor: pointer;
    }
</style>